
import whenDomReady from 'when-dom-ready';
import Splide from '@splidejs/splide';
import './jquery-global.js';
import 'bootstrap';
import '../../node_modules/vanilla-cookieconsent/dist/cookieconsent.js';
import '../../node_modules/@orestbida/iframemanager/dist/iframemanager.js';
import L from '../../node_modules/leaflet/dist/leaflet.js';
import GLightbox from 'glightbox';
import { CountUp } from '../../node_modules/countup.js/dist/countUp.js';
import '../../vendor/timeline/src/js/timeline.js';


whenDomReady(() => {
    const body = document.querySelector('body');


    const splideNewsContainers = document.querySelectorAll('.news-slider .splide');
    if (splideNewsContainers.length > 0) {
        new Splide('.news-slider .splide',
            {
                gap: '3em',
                speed: 700
            })
            .mount();
    }

    const splideVideoContainers = document.querySelectorAll('.video-slider .splide');
    if (splideVideoContainers.length > 0) {
        new Splide('.video-slider .splide', {
            gap: '4vw',
            perPage: 3,
            perMove: 1,
            pagination: false,
        }).mount();
    }

    const splideQuoteContainers = document.querySelectorAll('.quote-slider .splide');
    if (splideQuoteContainers.length > 0) {
        new Splide('.quote-slider .splide', {
            perPage: 1,
            pagination: false,
            type: 'loop',
            autoplay: true,
            interval: 5000
        }).mount();
    }



    const toggler = document.querySelectorAll('.mobile-nav-toggle');
    const mainNavigation = document.querySelector('#main-navigation');

    toggler.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            e.target.classList.toggle('active');
            mainNavigation.classList.toggle('active');
            body.classList.toggle('mobile-nav-open');
        });
    });



    if (!document.querySelector('.logged-in')) {
        const cc = initCookieConsent();
        window.cc = cc;
        cc.run({
            current_lang: 'de',
            autoclear_cookies: true,                   // default: false
            page_scripts: true,                        // default: false
            // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
            // delay: 0,                               // default: 0
            // auto_language: '',                      // default: null; could also be 'browser' or 'document'
            // autorun: true,                          // default: true
            // force_consent: false,                   // default: false
            // hide_from_bots: false,                  // default: false
            // remove_cookie_tables: false             // default: false
            // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
            // cookie_expiration: 182,                 // default: 182 (days)
            // cookie_necessary_only_expiration: 182   // default: disabled
            // cookie_domain: location.hostname,       // default: current domain
            // cookie_path: '/',                       // default: root
            // cookie_same_site: 'Lax',                // default: 'Lax'
            // use_rfc_cookie: false,                  // default: false
            // revision: 0,                            // default: 0

            onFirstAction: function(user_preferences, cookie) {
                // callback triggered only once on the first accept/reject action
            },

            onAccept: function(cookie) {
                // callback triggered on the first accept/reject action, and after each page load
            },

            onChange: function(cookie, changed_categories) {
                // callback triggered when user changes preferences after consent has already been given
            },

            languages: {
                'de': {
                    consent_modal: {
                        title: 'Wir verwenden Cookies',
                        description: 'Diese Internetseite verwendet Cookies und Matomo für die Analyse und Statistik. Cookies helfen uns, die Benutzerfreundlichkeit unserer Website zu verbessern. Weitere Informationen: <a href="https://www.fesloe.de/datenschutzerklarung/">Datenschutzerklärung</a><br><br><a href="#" data-cc="c-settings" class="cc-link">Verwendung individuell anpassen</a>',
                        primary_btn: {
                            text: 'Alle akzeptieren',
                            role: 'accept_all'
                        },
                        secondary_btn: {
                            text: 'Alle ablehnen',
                            role: 'accept_necessary'
                        }
                    },
                    settings_modal: {
                        title: 'Cookie-Einstellungen',
                        save_settings_btn: 'Auswahl akzeptieren',
                        accept_all_btn: 'Alle akzeptieren',
                        reject_all_btn: 'Alle ablehnen',
                        close_btn_label: 'Schließen',
                        cookie_table_headers: [
                            { col1: 'Name' },
                            { col2: 'Domain' },
                            { col3: 'Speicherdauer' },
                            { col4: 'Beschreibung' }
                        ],
                        blocks: [
                            {
                                title: 'Wir verwenden Cookies.',
                                description: 'Diese Internetseite verwendet Cookies und Matomo für die Analyse und Statistik. Cookies helfen uns, die Benutzerfreundlichkeit unserer Website zu verbessern. Zur <a href="https://www.fesloe.de/datenschutzerklarung">Datenschutzerklärung</a>.'
                            }, {
                                title: 'Notwendig',
                                description: 'Notwendige Cookies helfen dabei, eine Webseite nutzbar zu machen, indem sie Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Webseite ermöglichen. Die Webseite kann ohne diese Cookies nicht richtig funktionieren.',
                                toggle: {
                                    value: 'necessary',
                                    enabled: true,
                                    readonly: true
                                },
                                cookie_table: [
                                    {
                                        col1: 'wires',
                                        col2: window.location.hostname,
                                        col3: 'Bis zum Ende der Session',
                                        col4: 'Session-Cookie von ProcessWire',
                                    },
                                ]
                            }, {
                                title: 'Statistiken',
                                description: 'Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.',
                                toggle: {
                                    value: 'analytics',
                                    enabled: false,
                                    readonly: false
                                },
                                cookie_table: [
                                    {
                                        col1: '^_pk_id',
                                        col2: window.location.hostname,
                                        col3: '13 Monate',
                                        col4: 'Matomo (Anonymisierte Zugriffsstatistiken)',
                                        is_regex: true,
                                    },
                                    {
                                        col1: '^_pk_ref',
                                        col2: window.location.hostname,
                                        col3: '6 Monate',
                                        col4: 'Matomo (Anonymisierte Zugriffsstatistiken)',
                                        is_regex: true,
                                    },
                                    {
                                        col1: '^_pk_ses',
                                        col2: window.location.hostname,
                                        col3: '30 Minuten',
                                        col4: 'Matomo (Anonymisierte Zugriffsstatistiken)',
                                        is_regex: true,
                                    },
                                    {
                                        col1: '^_pk_cvar',
                                        col2: window.location.hostname,
                                        col3: '30 Minuten',
                                        col4: 'Matomo (Anonymisierte Zugriffsstatistiken)',
                                        is_regex: true,
                                    },
                                    {
                                        col1: '^_pk_hsr',
                                        col2: window.location.hostname,
                                        col3: '30 Minuten',
                                        col4: 'Matomo (Anonymisierte Zugriffsstatistiken)',
                                        is_regex: true,
                                    },
                                    {
                                        col1: '^_pk_testcookie',
                                        col2: window.location.hostname,
                                        col3: '30 Sekunden',
                                        col4: 'Matomo (Anonymisierte Zugriffsstatistiken)',
                                        is_regex: true,
                                    },
                                ]
                            },
                        ]
                    }
                }
            },

            gui_options: {
                consent_modal: {
                    layout: 'bar',                 // box/cloud/bar
                    position: 'bottom center',     // bottom/middle/top + left/right/center
                    transition: 'slide',           // zoom/slide
                    swap_buttons: false            // enable to invert buttons
                },
                settings_modal: {
                    layout: 'box',                 // box/bar
                    // position: 'left',           // left/right
                    transition: 'slide'            // zoom/slide
                }
            }
        });
    }


    const glightbox = GLightbox({
        plyr: {
            config: {
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'pip', 'airplay', 'fullscreen']
            }
        }
    });

    const glightboxPortraitVideo = GLightbox({
        selector: '.glightbox-portraitvideo',
        videosWidth: '100%',
        plyr: {
            debug: true,
            css: '/site/templates/node_modules/plyr/dist/plyr.css',
            js: '/site/templates/node_modules/plyr/dist/plyr.min.js',
            iconUrl: 'https://fesloe.ddev.site/site/templates/node_modules/plyr/dist/plyr.svg',
            config: {
                ratio: '9:16',
                muted: false,
                hideControls: true
            }
        }
    });


    const im = iframemanager();
    im.run({
        currLang: 'en',
        services : {
            openstreetmap : {
                embedUrl: 'https://www.youtube-nocookie.com/embed/{data-id}',
                thumbnailUrl: 'https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg',
                iframe : {
                    allow : 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;'
                },
                languages : {
                    en : {
                        notice: 'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">terms and conditions</a> of youtube.com.',
                        loadBtn: 'Load video',
                        loadAllBtn: "Don't ask again"
                    }
                }
            }
        }
    });

    function initLocationMap(geoData) {
        var map = L.map('locations-map',
            {
                zoomControl: false,
                attributionControl: false,
                boxZoom: false,
                doubleClickZoom: false,
                dragging: false,
                scrollWheelZoom: false,
                keyboard: false,
                touchZoom: false,
            }).setView([47.7, 8], 10);

        // L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        //     maxZoom: 19,
        //     attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        // }).addTo(map);

        const statesLayerOptions = {
            color: '#646464',
            fillColor: '#a9dfe7',
            fillOpacity: '0.4',
            weight: 4,
        };

        const tooltipOptions = {
            permanent: true,
            opacity: 1,
        };

        const locations = [
            {
                tooltip: 'Lörrach',
                name: 'Freie Evangelische Schule Lörrach',
                description: 'Grundschule, Werkrealschule, Realschule, Gymnasium und Berufliches Gymnasium',
                address: 'Austraße 19<br>79540 Lörrach',
                coordinates: [47.60194928612844, 7.654107213020325],
                url: 'https://www.fesloe.de',
                offset: [0, 0]
            },
            {
                tooltip: 'Müllheim',
                name: 'Freie Evangelische Schule Müllheim',
                description: 'Grundschule, Werkrealschule, Realschule, Gymnasium und Berufliches Gymnasium',
                address: 'Austraße 19<br>79540 Lörrach',
                coordinates: [47.81439195382526, 7.620421350002289],
                url: 'https://www.fes-muellheim.de',
                offset: [50, 200]
            },
            {
                tooltip: 'Schopfheim',
                name: 'Christliche Schule Schopfheim',
                description: 'Grundschule, Werkrealschule, Realschule, Gymnasium und Berufliches Gymnasium',
                address: 'Austraße 19<br>79540 Lörrach',
                coordinates: [47.65068694896735, 7.83075213432312],
                url: 'https://www.css-schopfheim.de',
                offset: [0, 0]
            },
            {
                tooltip: 'Kandern',
                name: 'Christliche Schule Kandern',
                description: 'Grundschule, Werkrealschule, Realschule, Gymnasium und Berufliches Gymnasium',
                address: 'Austraße 19<br>79540 Lörrach',
                coordinates: [47.670052068320615, 7.650482207536697],
                url: 'https://www.csk-kandern.de',
                offset: [0, 0]
            },
            {
                tooltip: 'Waldshut-Tiengen',
                name: 'Christliche Schule Hochrhein',
                description: 'Grundschule und Realschule',
                address: 'Gurtweiler Straße 2<br>' +
                         '79761 Waldshut-Tiengen',
                coordinates: [47.62245, 8.22161],
                url: 'https://www.csh-waldshut.de',
                offset: [0, 0]
            },


        ];

        L.geoJSON(geoData, {
            style: statesLayerOptions
        }).addTo(map);

        locations.forEach((location) => {
            L.marker(location.coordinates).addTo(map)
                .bindTooltip(location.tooltip, tooltipOptions)
                .bindPopup('<div class="popup-title">'
                    + location.name + '</div><p>'
                    + location.description
                    + '</p><p>' + location.address
                    + '</p><p><a href="' + location.url + '" target="_blank">Zur Website</a>'
                    + '</p>',
                {
                    autoPan: false,
                    offset: location.offset
                })
                .on('mouseover', function () {
                    this.openPopup();
                })
                .on('mouseout', function () {
                    //this.closePopup();
                });
        });

    }

    if (document.getElementById('locations-map')) {
        fetch('/site/templates/data/maps/landkreise.geojson')
            .then((response) => response.json())
            .then((json) => initLocationMap(json));
    }


    const countUpElements = document.querySelectorAll('.count-up');
    countUpElements.forEach((countUpElement) => {
        new CountUp(countUpElement, countUpElement.dataset.countto, {
            enableScrollSpy: true,
            duration: 3,
            useGrouping: false
        });
    });


    let timelineItems = 4;
    if (window.innerWidth < 1200) {
        timelineItems = 3;
    }
    if (window.innerWidth < 992) {
        timelineItems = 2;
    }
    jQuery('.timeline').timeline({
        mode: 'horizontal',
        visibleItems: timelineItems,
        forceVerticalMode: 767,
    });

});
